import * as types from './actionTypes';

export const fetchResourceApproval = (payload) => ({
  type: types.FETCH_RESOURCE_APPROVAL_REQUEST,
  payload,
});

export const updateResourceApproval = (payload) => ({
  type: types.UPDATE_RESOURCE_APPROVAL_REQUEST,
  payload,
});

export const fetchJobDetailsApproval = (payload) => ({
  type: types.FETCH_JOBDETAILS_APPROVAL_REQUEST,
  payload,
});
